var map = {
	"./logo_en.png": 97355,
	"./logo_hongqi.png": 40502,
	"./logo_icaur.png": 30872,
	"./logo_undefined.png": 316,
	"./logo_zeekr.png": 58871,
	"./logo_zeekr2.png": 80869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24013;